import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import ContactForm from "../../components/Contacts/ContactForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const ContactsEdit = ({classes, contact, subs, contactType, formUrl, uploadConfig, redirectAfterSubmit, isEmployee,newAddressNumbers}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('contacts.edit_' + contactType)}
        />

        <Card>
            <CardContent>
                <ContactForm
                    values={contact}
                    subContacts={subs}
                    uploadConfig={uploadConfig}
                    contactType={contactType}
                    formUrl={formUrl}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                    isEmployee={isEmployee}
                    newAddressNumbers={newAddressNumbers}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default ContactsEdit;
